import { ReactiveFormHostState } from './reactive-form-host-state';

export interface ReactiveFormHostPreviousDataOptions<TModel> {
    readonly state: ReactiveFormHostState<TModel>;
    readonly previousData: TModel | null | undefined;
}

export interface ReactiveFormHostPreviousDataResolveOptions<TModel> {
    readonly state: ReactiveFormHostState<TModel>;
    readonly fallbackModel?: TModel | null | undefined;
}

/** Owns previousData assignment and fallback resolution for host components. */
export class ReactiveFormHostPreviousDataController {
    public static setPreviousData<TModel>(options: ReactiveFormHostPreviousDataOptions<TModel>): TModel | null {
        const previousData = options.previousData ?? null;

        options.state.setPreviousData(previousData);
        return previousData;
    }

    public static setPreviousDataFromModel<TModel>(state: ReactiveFormHostState<TModel>): TModel {
        state.setPreviousData(state.model);
        return state.model;
    }

    public static resolvePreviousData<TModel>(options: ReactiveFormHostPreviousDataResolveOptions<TModel>): TModel | null {
        return options.state.previousData ?? options.fallbackModel ?? null;
    }
}
